import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 560px;
`;

export const Content = styled.div`
  padding: 50px 30px 15px 30px;

  @media only screen and (max-width: 600px) {
    padding: 50px 15px 15px 15px;
  }
`;